import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { Button, Modal, Form, Dropdown } from 'semantic-ui-react';

export default function ContingentContainer({ rates = null, onAccept, onClose, contingentsElements, showModal = null }) {
    const { t } = useTranslation();
    const [contingentsToAdd, setContingentsToAdd] = React.useState([]);
    const [contingentsToDelete, setContingentsToDelete] = React.useState([]);

    if (!rates || !rates.length || !showModal) {
        return null;
    }
    const mapToOptions = ({ uuid, name }) => ({ key: uuid, text: name, value: uuid });
    let optionsContingentsToAdd = contingentsElements.map(mapToOptions);
    let optionsContingentsToDelete = Array.from(optionsContingentsToAdd);

    function updateList(choiceContingents, value) {
        const newContingents = value;
        return choiceContingents === 'contingentsToAdd' ? setContingentsToAdd([...newContingents]) : setContingentsToDelete([...newContingents]);
    }

    return (
        <Modal open={Boolean(rates)} onClose={onClose} onHide={onClose}>
            <Modal.Header>{t(`ticket.rates.editContingents`)}</Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field>
                        <label>{t(`ticket.rates.contingentsToAdd`)}</label>
                        <Dropdown
                            clearable
                            fluid
                            search
                            selection
                            options={optionsContingentsToAdd}
                            onChange={(synth, data) => updateList('contingentsToAdd', data.value)}
                            value={contingentsToAdd}
                            multiple
                        ></Dropdown>
                    </Form.Field>
                    <Form.Field>
                        <label>{t(`ticket.rates.contingentsToDelete`)}</label>
                        <Dropdown
                            clearable
                            fluid
                            search
                            selection
                            options={optionsContingentsToDelete}
                            onChange={(synth, data) => updateList('contingentsToDelete', data.value)}
                            value={contingentsToDelete}
                            multiple
                        ></Dropdown>
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    onClick={() => {
                        onClose();
                    }}
                    content={t(`ticket.common.action.cancel`)}
                />
                <Button
                    icon
                    color="blue"
                    labelPostion="left"
                    onClick={() => {
                        onAccept([contingentsToAdd, contingentsToDelete]);
                    }}
                >
                    {t(`ticket.common.action.save`)}
                </Button>
            </Modal.Actions>
        </Modal>
    );
}

ContingentContainer.propTypes = {
    rates: PropTypes.array.isRequired,
    onAccept: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    contingentsElements: PropTypes.array.isRequired,
    showModal: PropTypes.bool
};
